/* Layout Grid — mobile carousel pagination dots.
   Uses CSS scroll-snap; JS only mirrors the active slide state as dots and lets the user click a dot to scroll. */
(function () {
  const MOBILE_BREAKPOINT = 749;

  function initSection(root) {
    if (!root || root.dataset.layoutGridInit === "1") return;
    root.dataset.layoutGridInit = "1";

    const track = root.querySelector("[data-track]");
    const pagination = root.querySelector("[data-pagination]");
    if (!track || !pagination) return;

    const tiles = Array.from(track.querySelectorAll(".layout-grid__tile"));
    if (tiles.length < 2) return;

    pagination.innerHTML = "";
    tiles.forEach((_, i) => {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.setAttribute("aria-label", `Slide ${i + 1}`);
      dot.addEventListener("click", () => {
        const tile = tiles[i];
        track.scrollTo({ left: tile.offsetLeft - track.offsetLeft, behavior: "smooth" });
      });
      pagination.appendChild(dot);
    });

    const dots = Array.from(pagination.querySelectorAll("button"));

    function setActive(index) {
      dots.forEach((dot, i) => {
        if (i === index) dot.setAttribute("aria-current", "true");
        else dot.removeAttribute("aria-current");
      });
    }

    setActive(0);

    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              const idx = tiles.indexOf(entry.target);
              if (idx !== -1) setActive(idx);
            }
          });
        },
        { root: track, threshold: [0.6] }
      );
      tiles.forEach((tile) => io.observe(tile));
    }

    function updatePaginationVisibility() {
      if (window.innerWidth > MOBILE_BREAKPOINT) {
        pagination.setAttribute("hidden", "");
      } else {
        pagination.removeAttribute("hidden");
      }
    }
    updatePaginationVisibility();
    window.addEventListener("resize", updatePaginationVisibility);
  }

  function init() {
    document
      .querySelectorAll(".layout-grid[data-mobile-layout='carousel']")
      .forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (e) => {
    const root = e.target.querySelector(".layout-grid[data-mobile-layout='carousel']");
    if (root) initSection(root);
  });
})();
